import { render, staticRenderFns } from "./Gongsi0.vue?vue&type=template&id=4057f8e4&scoped=true&"
import script from "./Gongsi0.vue?vue&type=script&lang=js&"
export * from "./Gongsi0.vue?vue&type=script&lang=js&"
import style0 from "./Gongsi0.vue?vue&type=style&index=0&id=4057f8e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4057f8e4",
  null
  
)

export default component.exports